// extracted by mini-css-extract-plugin
export var bestFor = "s_bg";
export var ctaButton = "s_bf";
export var icons = "s_bd";
export var mainHeadRow = "s_bb";
export var secondaryHeadRow = "s_bc";
export var tableContainer = "s_9";